import { GetElectionResponse, PendingVote } from '../types';
import { LitElement, css, html } from 'lit';
import { customElement, property, queryAsync, state } from 'lit/decorators';
import { electionVotingIsHappening, isVoterEligible } from '../helpers/api/election-api';
import { isDefined, undefinedIfEmpty } from '../helpers/utils';

import { ElectionFormComponent } from '../components/election-form-component';
import { StateController } from '../helpers/state/state-management/state-controller';
import accountInfo from '../helpers/state/account-info';
import challengeData from '../helpers/state/challenge-data';
import pointCache from '../helpers/state/point-cache';
import topicData from '../helpers/state/topic-data';

@customElement('ballot-page')
export class BallotPage extends LitElement {
    amplitude_callsite: string = 'Ballot Page';

    @queryAsync('#electionForm')
    electionFormElement!: ElectionFormComponent;

    @property()
    election?: GetElectionResponse;

    @state()
    pendingVote?: PendingVote;

    private readonly bindTopicState = new StateController(this, topicData);
    private readonly bindPointCacheState = new StateController(this, pointCache);
    private readonly bindAccountState = new StateController(this, accountInfo);

    async firstUpdated() {
        await this.startup();
    }

    private async startup() {
        await topicData.instantiateTopicData(
            this.amplitude_callsite,
            accountInfo.isAuthenticated,
            false,
            true
        );
        this.election = topicData.electionHappeningNow;
        if (isDefined(topicData.topic)) {
            await pointCache.instantiatePointCache(
                topicData.topic,
                topicData.topicKey,
                false,
                false,
                challengeData.challenge ? challengeData.allCheckins : accountInfo.account_checkins
            );
        }
        const email = undefinedIfEmpty(accountInfo.email) ?? localStorage.getItem('email') ?? '';
        if (topicData.electionHappeningNow) {
            const eligible = await isVoterEligible(topicData.electionHappeningNow, email);
            topicData.ballotEligible = eligible;
        }
        window.dispatchEvent(new CustomEvent('page-content-ready'));
    }

    private async closeElectionModal() {
        await this.startup();
    }

    private async openThisMap() {
        // get topic key
        const queryString = window.location.href.split('?')[1];
        const params = new URLSearchParams(queryString);
        const topicKey = params.get('topic_key');

        // open URL
        const openURL = `${window.location.origin}/#command-center?topic_id=${topicData.topicId}&topic_key=${topicKey ?? ''}`;
        window.open(openURL, '_blank');
    }

    render() {
        return topicData.isReady
            ? html`
                <div class="points__page_wrapper">
                    <div class="points__content_wrapper">
                        <div class="points__header">
                            <map-header>
                                <form-button size="sm" class="points__view_map" variant="custom" style="--btn-border-color:${topicData.topic?.header_text_color};--btn-label-color:${topicData.topic?.header_text_color};--btn-background-color:transparent;" @click="${async () => await this.openThisMap()}">
                                <mwc-icon>open_in_new</mwc-icon>
                                Open Map
                                </form-button>
                            </map-header>
                        </div>
                        <div class="points__middle_content">
                            ${isDefined(this.election) && electionVotingIsHappening(this.election) ? html`
                                <div class="form-holder">
                                    <election-form-component
                                        style="width: 100%;"
                                        id="electionForm"
                                        .pendingVote="${this.pendingVote}"
                                        @on-close="${this.closeElectionModal}"
                                    ></election-form-component>
                                </div>
                                ` : html`
                                <div class="form-holder">
                                    <h3>Voting is not currently happening.</h3>
                                </div>
                            `}
                        </div>
                    </div>
                </div>
                <error-toast id="errorToast"></error-toast> `
            : '';
    }

    static get styles() {
        return css`

            .form-holder {
                display: flex;
                justify-content: center;
                width: 100%;
                height: 100%;
            }

            .points__page_wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 50px 15%;
                min-height: 100vh;
            }

            .points__content_wrapper {
                display: flex;
                flex-direction: column;
                width: 100%;
                max-width: 1200px;
                justify-content: center;
                background-color: white;
                border-radius: 10px;
                height:100vh;
                justify-content: flex-start;
            }

            .points__view_map {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                --btn-label-color: white;
                border-radius: 10px 10px 0 0;
            }

            .points__middle_content {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                overflow: auto;
                align-items: top;
                padding: 0 25px;
                gap: 25px;
            }


            p {
                margin-top: 5px;
                margin-bottom: 0;
            }

            h2 {
                margin-bottom: 0px;
            }

            h4 {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .inline_words {
                display: inline-flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: flex-start;
                gap: 5px;
            }

            .inline_words p {
                margin-bottom: 5px;
            }

            .inline_words h2 {
                margin-top: 0;
            }

            .sparkles {
                height: 20px;
            }

            .hide_on_desktop {
                display: none;
            }

            @media only screen and (max-width: 550px) {
                .points__page_wrapper {
                    padding: 0;
                }

                .points__middle_content {
                    flex-direction: column;
                    align-items: center;
                    padding: 10px;
                }

                .hide_on_mobile {
                    display: none;
                }

                .hide_on_desktop {
                    display: flex;
                }

            }



        `;
    }
}

